// What a failed People or Company search says. A 4xx is about the request
// (a filter value the search can't use, a plan gate), so it must not read as
// an outage: "temporarily unavailable, try again" sent people retrying a
// search that could never run. Provider wording never reaches the screen.

export const INVALID_FILTER_MESSAGE =
  "One of your filters has a value the search can't use. Check the filters and try again.";

/** The HTTP status on an RTK Query or async-poll error, if it has one. */
function errorStatus(err: unknown): number | undefined {
  const status =
    typeof err === 'object' && err !== null
      ? (err as { status?: unknown }).status
      : undefined;
  return typeof status === 'number' ? status : undefined;
}

/** `detail` when it is a string, or `detail.message` for `{ code, message }`. */
export function errorDetailMessage(err: unknown): string | undefined {
  const data =
    typeof err === 'object' && err !== null
      ? (err as { data?: unknown }).data
      : undefined;
  const detail =
    typeof data === 'object' && data !== null
      ? (data as { detail?: unknown }).detail
      : data;
  if (typeof detail === 'string') return detail;
  const message =
    typeof detail === 'object' && detail !== null
      ? (detail as { message?: unknown }).message
      : undefined;
  return typeof message === 'string' ? message : undefined;
}

/** `message`, unless it names the provider: then a 4xx reads as a filter
 *  problem and anything else as an outage of `surface`. */
export function searchFailureCopy(
  message: string,
  err: unknown,
  surface: 'People Finder' | 'Company search'
): string {
  if (!/crustdata|upstream/i.test(message)) return message;
  const status = errorStatus(err);
  return status !== undefined && status >= 400 && status < 500
    ? INVALID_FILTER_MESSAGE
    : `${surface} is temporarily unavailable. Please try again in a few minutes.`;
}
